/**
 * Video vitrin — masaüstü carousel + mobil Instagram Story
 */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 750px)');
  var ICON_OFF =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  var ICON_ON =
    '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>';

  function initStories(root) {
    if (!root || root.dataset.storiesReady) return;
    root.dataset.storiesReady = '1';

    var viewport = root.querySelector('[data-stories-viewport]');
    var track = root.querySelector('[data-stories-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-stories-slide]'));
    if (!slides.length || !viewport || !track) return;

    var bars = Array.prototype.slice.call(root.querySelectorAll('[data-stories-bar]'));
    var fills = Array.prototype.slice.call(root.querySelectorAll('[data-stories-fill]'));
    var prevBtn = root.querySelector('[data-stories-prev]');
    var nextBtn = root.querySelector('[data-stories-next]');
    var tapPrev = root.querySelector('[data-stories-tap-prev]');
    var tapNext = root.querySelector('[data-stories-tap-next]');

    var autoplay = root.dataset.autoplay !== 'false';
    var muted = root.dataset.muted !== 'false';
    var fallbackMs = parseInt(root.dataset.fallback, 10) || 8000;
    var index = 0;
    var timer = null;
    var raf = null;
    var visible = true;
    var userUnlocked = false;

    var tStartX = 0;
    var tStartY = 0;
    var tDeltaX = 0;
    var tActive = false;
    var tDecided = false;
    var tHorizontal = false;

    function isDesktop() {
      return DESKTOP.matches;
    }

    function isMobile() {
      return !DESKTOP.matches;
    }

    function wrap(i) {
      var n = slides.length;
      return ((i % n) + n) % n;
    }

    function offset(i) {
      var d = i - index;
      var half = slides.length / 2;
      if (d > half) d -= slides.length;
      if (d < -half) d += slides.length;
      return d;
    }

    function clearTimer() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    }

    function stopRaf() {
      if (raf) {
        cancelAnimationFrame(raf);
        raf = null;
      }
    }

    function pauseAll() {
      slides.forEach(function (slide) {
        var v = slide.querySelector('video');
        if (!v) return;
        v.pause();
        v.onended = null;
        v.ontimeupdate = null;
      });
    }

    function updateBars() {
      bars.forEach(function (bar, i) {
        bar.classList.toggle('is-active', i === index);
        bar.classList.toggle('is-done', i < index);
        if (fills[i]) fills[i].style.width = i < index ? '100%' : '0%';
      });
    }

    function applyMutedToAllVideos() {
      slides.forEach(function (slide) {
        var v = slide.querySelector('video');
        if (v) v.muted = muted;
      });
    }

    function syncMuteBtn() {
      slides.forEach(function (slide, i) {
        var btn = slide.querySelector('[data-stories-mute]');
        var video = slide.querySelector('video');
        if (!btn) return;
        if (!video) {
          btn.hidden = true;
          return;
        }
        btn.hidden = i !== index;
        btn.setAttribute('aria-label', muted ? 'Sesi aç' : 'Sesi kapat');
        btn.setAttribute('aria-pressed', muted ? 'false' : 'true');
        var icon = btn.querySelector('[data-stories-mute-icon]');
        if (icon) icon.innerHTML = muted ? ICON_OFF : ICON_ON;
      });
    }

    function startBarTimer(ms) {
      stopRaf();
      var fill = fills[index];
      if (!fill || !ms) return;
      var start = performance.now();
      function tick(now) {
        var pct = Math.min(((now - start) / ms) * 100, 100);
        fill.style.width = pct + '%';
        if (pct < 100) raf = requestAnimationFrame(tick);
      }
      raf = requestAnimationFrame(tick);
    }

    function scheduleAdvance(ms) {
      clearTimer();
      if (!autoplay || slides.length < 2) return;
      timer = setTimeout(function () {
        go(index + 1);
      }, ms);
    }

    function tryPlay(video, cb) {
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      /* Ortak ses tercihi — bir kez açılınca tüm videolarda geçerli */
      video.muted = muted;

      var promise = video.play();
      if (!promise || !promise.then) {
        if (cb) cb(true);
        return;
      }

      promise
        .then(function () {
          if (cb) cb(true);
        })
        .catch(function () {
          /* Tarayıcı sesli oynatmayı engellerse sadece bu denemede sessize al */
          video.muted = true;
          video
            .play()
            .then(function () {
              if (!muted) {
                video.muted = false;
              }
              if (cb) cb(true);
            })
            .catch(function () {
              muted = true;
              applyMutedToAllVideos();
              syncMuteBtn();
              if (cb) cb(false);
            });
        });
    }

    function playActive() {
      if (!visible) return;

      var slide = slides[index];
      if (!slide) return;

      var video = slide.querySelector('video');
      syncMuteBtn();

      slides.forEach(function (s, i) {
        var v = s.querySelector('video');
        if (!v) return;
        if (i !== index) {
          v.pause();
          v.onended = null;
          v.ontimeupdate = null;
        }
      });

      if (!video) {
        startBarTimer(fallbackMs);
        scheduleAdvance(fallbackMs);
        return;
      }

      function bindVideoEvents() {
        video.onended = function () {
          if (autoplay && slides.length > 1) go(index + 1);
        };
        video.ontimeupdate = function () {
          if (!video.duration || !fills[index]) return;
          fills[index].style.width = Math.min((video.currentTime / video.duration) * 100, 100) + '%';
        };
        var dur = video.duration && isFinite(video.duration) ? video.duration * 1000 + 300 : fallbackMs;
        scheduleAdvance(Math.max(fallbackMs, dur));
      }

      function startPlayback() {
        tryPlay(video, function (ok) {
          if (!ok) return;
          bindVideoEvents();
        });
      }

      if (video.readyState >= 2) {
        startPlayback();
      } else {
        video.preload = 'auto';
        video.addEventListener(
          'canplay',
          function () {
            startPlayback();
          },
          { once: true }
        );
        video.addEventListener(
          'loadeddata',
          function () {
            startPlayback();
          },
          { once: true }
        );
      }
    }

    function layoutDesktop() {
      var center = Math.floor(slides.length / 2);
      slides.forEach(function (slide, i) {
        slide.classList.remove('is-active', 'is-near', 'is-far', 'is-hidden');
        var d = offset(i);
        if (d === 0) slide.classList.add('is-active');
        else if (Math.abs(d) === 1) slide.classList.add('is-near');
        else if (Math.abs(d) === 2) slide.classList.add('is-far');
        else slide.classList.add('is-hidden');
        slide.style.order = String(d + center);
      });
      track.style.transform = '';
      track.style.transition = '';
    }

    function layoutMobile(animate) {
      var w = viewport.offsetWidth;
      track.style.transition = animate === false ? 'none' : 'transform .32s cubic-bezier(.22,1,.36,1)';
      track.style.transform = 'translate3d(' + -index * w + 'px,0,0)';
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
    }

    function applyLayout(animate) {
      if (isDesktop()) {
        layoutDesktop();
      } else {
        layoutMobile(animate);
      }
      updateBars();
    }

    function go(next, opts) {
      opts = opts || {};
      var animate = opts.animate !== false;
      var resetVideo = opts.reset !== false;
      clearTimer();
      stopRaf();
      pauseAll();

      var prev = index;
      index = wrap(next);

      if (resetVideo) {
        var v = slides[index].querySelector('video');
        if (v && prev !== index) v.currentTime = 0;
      }

      applyMutedToAllVideos();
      applyLayout(animate);
      playActive();
    }

    function unlockAndPlay() {
      if (userUnlocked) return;
      userUnlocked = true;
      playActive();
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(index + 1); });

    function toggleMute(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      muted = !muted;
      userUnlocked = true;
      applyMutedToAllVideos();
      var v = slides[index] ? slides[index].querySelector('video') : null;
      if (v) {
        v.muted = muted;
        if (v.paused) {
          v.play().catch(function () {
            if (!muted) {
              muted = true;
              applyMutedToAllVideos();
              syncMuteBtn();
            }
          });
        }
      }
      syncMuteBtn();
    }

    /* Ses butonu — doğrudan bağla; tap katmanı video değiştirmesin */
    slides.forEach(function (slide) {
      var muteBtn = slide.querySelector('[data-stories-mute]');
      if (!muteBtn) return;
      muteBtn.addEventListener('click', toggleMute);
      muteBtn.addEventListener('touchend', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleMute(e);
      });
    });

    /* Mobilde: sol dokunma = önceki, sağ dokunma = sonraki (Story) */
    if (tapPrev) {
      tapPrev.addEventListener('click', function (e) {
        if (e.target.closest('[data-stories-mute], a, button')) return;
        if (isMobile()) go(index - 1);
      });
    }
    if (tapNext) {
      tapNext.addEventListener('click', function (e) {
        if (e.target.closest('[data-stories-mute], a, button')) return;
        if (isMobile()) go(index + 1);
      });
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-stories-mute], a, button')) return;
      if (!isDesktop() || slides.length < 2) return;
      var slideEl = e.target.closest('[data-stories-slide]');
      if (!slideEl) return;
      var ti = slides.indexOf(slideEl);
      if (ti >= 0 && ti !== index) go(ti);
    });

    /* Mobilde soldan sağa kaydır = sonraki video */
    function onTouchStart(e) {
      if (!isMobile()) return;
      if (e.target.closest('[data-stories-mute], a, button, .ev-stories__cta')) {
        tActive = false;
        return;
      }
      unlockAndPlay();
      if (slides.length < 2) return;
      tStartX = e.touches[0].clientX;
      tStartY = e.touches[0].clientY;
      tDeltaX = 0;
      tActive = true;
      tDecided = false;
      tHorizontal = false;
    }

    function onTouchMove(e) {
      if (!tActive || !isMobile()) return;
      var dx = e.touches[0].clientX - tStartX;
      var dy = e.touches[0].clientY - tStartY;

      if (!tDecided) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        tDecided = true;
        if (Math.abs(dy) >= Math.abs(dx)) {
          tActive = false;
          return;
        }
        tHorizontal = true;
        track.style.transition = 'none';
      }

      if (!tHorizontal) return;

      e.preventDefault();
      tDeltaX = dx;
      var w = viewport.offsetWidth || 1;
      var x = -index * w + dx;
      if (index === 0 && dx < 0) x = -index * w + dx * 0.35;
      if (index === slides.length - 1 && dx > 0) x = -index * w + dx * 0.35;
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    }

    function onTouchEnd() {
      if (!tActive || !isMobile()) {
        tActive = false;
        return;
      }
      track.style.transition = 'transform .32s cubic-bezier(.22,1,.36,1)';
      if (tHorizontal) {
        var threshold = (viewport.offsetWidth || 300) * 0.15;
        if (tDeltaX > threshold) go(index + 1);
        else if (tDeltaX < -threshold) go(index - 1);
        else layoutMobile(true);
      } else {
        layoutMobile(true);
      }
      tActive = false;
      tHorizontal = false;
      tDecided = false;
    }

    viewport.addEventListener('touchstart', onTouchStart, { passive: true });
    viewport.addEventListener('touchmove', onTouchMove, { passive: false });
    viewport.addEventListener('touchend', onTouchEnd, { passive: true });
    viewport.addEventListener('touchcancel', onTouchEnd, { passive: true });

    DESKTOP.addEventListener('change', function () {
      go(index, { animate: false, reset: false });
    });

    window.addEventListener('resize', function () {
      if (isMobile()) layoutMobile(false);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.target !== root) return;
            visible = entry.isIntersecting && entry.intersectionRatio > 0.15;
            if (visible) {
              playActive();
            } else {
              pauseAll();
              clearTimer();
              stopRaf();
            }
          });
        },
        { threshold: [0, 0.15, 0.35], rootMargin: '40px 0px' }
      ).observe(root);
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        pauseAll();
        clearTimer();
        stopRaf();
      } else if (visible) {
        playActive();
      }
    });

    applyLayout(false);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        playActive();
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ev-stories]:not([data-stories-ready])').forEach(initStories);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
